import React from 'react'
import { Element } from 'react-scroll'
import { Parallax } from 'react-scroll-parallax'

import '../styles/Landing.scss'
import Hero from '../lp02-cover.png'
import Email from './Email/Email'
import ButtonLink from './ButtonLink/ButtonLink'

const Landing = () => (
  <Element id="home" name="home">
    <div className="container main-body page-section">
      <div className="landing-container">
        <Parallax y={[20, -20]} className="album-art-container">
          <img
            className="landing album-art"
            src={Hero}
            alt="Rope and Ladder: This is Wild, band music album art"
          />
        </Parallax>
        <div className="coming-soon-date">The new album</div>
        <div className="coming-soon-text">"This is Wild"</div>
        <div className="coming-soon-date">Now streaming everywhere</div>
        <Email />
      </div>
    </div>
  </Element>
)

export default Landing
